import { styled } from "@mui/material"
import { ReactComponent as HelpIcon } from "../../assets/images/menu-question-mark.svg"

export const StyledHelpIcon = styled(HelpIcon)`
  width: 1.3em;
  height: 1.3em;
`
